import { Text, View } from '@react-pdf/renderer'
import { customerDataStyles } from './customerDataStyles';

const { customerData } = customerDataStyles();

export const CustomerData = ({data,showTranslatedText}:any) => {
    return (
        <View fixed style={customerData.container}>
            <View style={customerData.firstSubContainer}>
                <View style={customerData.titleContainer} >
                    <Text style={customerData.title}>{showTranslatedText("reports.salesPreorderPdf.customerData.billTo")}:</Text>
                </View>
                <View style={customerData.dataContainer}>
                    <View style={customerData.firstContainer}>
                        <Text style={customerData.data}>{data.dataSalesPreorders.customer_business_name || ' '}</Text>
                        <Text style={customerData.data}>{data.dataSalesPreorders.customer_street_name || ' '}</Text>
                        <Text style={customerData.data}>{data.dataSalesPreorders.customer_city_name || ' '}</Text>
                        <Text style={customerData.data}>{data.dataSalesPreorders.customer_state_name || ' '} {data.dataSalesPreorders.customer_postal_code || ' '}, {data.dataSalesPreorders.customer_country_name || ' '}</Text>
                    </View>
                    <View style={customerData.secondContainer}>
                        <View style={customerData.field}>
                            <View style={{ width: '50%', paddingBottom: 5 }}>
                                <Text style={customerData.concept}>{showTranslatedText("reports.salesPreorderPdf.header.taxId")}:</Text>
                            </View>
                            <Text style={customerData.data}>{data.dataSalesPreorders.customer_rfc || ' '}</Text>
                        </View>
                        <View style={customerData.field}>
                            <Text style={customerData.concept}>{data.dataSalesPreorders.customer_tax_regime_code || ' '}:  </Text>
                            <Text style={customerData.data}>{data.dataSalesPreorders.customer_tax_regime_description || ' '}</Text>
                        </View>
                        <View style={customerData.field}>
                            <Text style={customerData.concept}>{showTranslatedText("reports.salesPreorderPdf.customerData.email")}:</Text>
                            <Text style={customerData.data}>{data.dataSalesPreorders.customer_email || ' '}</Text>
                        </View>
                        <View style={customerData.field}>
                            <Text style={customerData.concept}>{showTranslatedText("reports.salesPreorderPdf.customerData.telephone")}:</Text>
                            <Text style={customerData.data}>{data.dataSalesPreorders.customer_phone_number || ' '}</Text>
                        </View>
                    </View>
                </View>
            </View>
            <View style={customerData.secondSubContainer}>
                <View style={customerData.titleContainer}>
                    <Text style={customerData.title}>{showTranslatedText("reports.salesPreorderPdf.customerData.shipTo")}:</Text>
                </View>
                <View style={customerData.dataContainer}>
                    <View style={customerData.firstContainer}>
                        <Text style={customerData.data}>{data.dataSalesPreorders.customer_delivery_business_name || ' '}</Text>
                        <Text style={customerData.data}>{data.dataSalesPreorders.customer_delivery_street || ' '}</Text>
                        <Text style={customerData.data}>{data.dataSalesPreorders.customer_delivery_city_name || ' '}</Text>
                        <Text style={customerData.data}>{data.dataSalesPreorders.customer_delivery_state_name || ' '} {data.dataSalesPreorders.customer_delivery_postal_code || ' '}, {data.dataSalesPreorders.customer_delivery_country_name || ' '}</Text>
                    </View>
                    <View style={customerData.secondContainer}>
                        <View style={customerData.field}>
                            <View style={{ width: '50%', paddingBottom: 5 }}>
                                <Text style={customerData.concept}>{showTranslatedText("reports.salesPreorderPdf.header.taxId")}:</Text>
                            </View>
                            <Text style={customerData.data}>{data.dataSalesPreorders.customer_delivery_rfc || ' '}</Text>
                        </View>
                        <View style={customerData.field}>
                            <Text style={customerData.concept}>{data.dataSalesPreorders.customer_delivery_tax_regime_code || ' '}:  </Text>
                            <Text style={customerData.data}>{data.dataSalesPreorders.customer_delivery_tax_regime_description || ' '}</Text>
                        </View>
                        <View style={customerData.field}>
                            <Text style={customerData.concept}>{showTranslatedText("reports.salesPreorderPdf.customerData.email")}:</Text>
                            <Text style={customerData.data}>{data.dataSalesPreorders.customer_delivery_email || ' '}</Text>
                        </View>
                        <View style={customerData.field}>
                            <Text style={customerData.concept}>{showTranslatedText("reports.salesPreorderPdf.customerData.telephone")}:</Text>
                            <Text style={customerData.data}>{data.dataSalesPreorders.customer_delivery_phone_number || ' '}</Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>

    )
}
